const newQuestionReducer = (state = {}, action) => {
    switch (action.type) {
      case "SET_NEW_QUESTION":
        return action.payload;
      default:
        return state;
    }
  }
  export default newQuestionReducer;